export default {
  data () {
    return {
      mobile: false,
      mobileThresholdWidthPx: 1243
    }
  },
  methods: {
    handleResize () {
      this.mobile = window.innerWidth <= this.mobileThresholdWidthPx
    }
  },
  mounted () {
    this.$nextTick(this.handleResize)
  }
}